import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { TypographyBreakpointNameList, typographyMixin, } from '../../theme/Typography/Typography.utils';
import { formTextDefaultColor, formTextPlaceholderColor, } from '../../utils/styled-components/color-mixins/color-mixins';
import { boxSizingBorderBox } from '../../utils/styled-components/extends';
import { Typography } from '../../theme/Typography/Typography';
import { getFixedSpacing } from '../../theme/Spacing/Spacing';
import { mq } from '../../theme/MediaQuery/MediaQuery';
var inputTypographyMixin = typographyMixin('text', '300');
export var inputElementBaseStylesMixin = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  box-sizing: border-box;\n  font: inherit;\n  color: currentColor;\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  padding: ", "px ", "px;\n  box-sizing: border-box;\n  font: inherit;\n  color: currentColor;\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), getVerticalPadding(), getFixedSpacing(1), formTextPlaceholderColor);
export var inputRootStylesMixin = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  ", ";\n  color: ", ";\n"
    /* For IE11 we need the height to be set.
     *  Once IE11 doesn't need support anymore, we probably can just have
     *  height: auto; and it stays the correct height because of the
     *  border-box, padding & line-height. */
])), inputTypographyMixin, boxSizingBorderBox, formTextDefaultColor);
/* For IE11 we need the height to be set.
 *  Once IE11 doesn't need support anymore, we probably can just have
 *  height: auto; and it stays the correct height because of the
 *  border-box, padding & line-height. */
export function singleLineInputIE11FixHeightMixin(_props) {
    return TypographyBreakpointNameList.reduce(function (acc, typographyBreakpoint) {
        var styles = Typography[typographyBreakpoint].text['300'];
        var lineHeight = styles.lineHeight;
        var padding = getVerticalPadding() * 2;
        acc[mq.min(typographyBreakpoint)] = {
            height: "calc((" + padding + "px) + (1em * " + lineHeight + "))",
        };
        return acc;
    }, {});
}
function getVerticalPadding() {
    return getFixedSpacing(0.5);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=input-styles.js.map